import { render, staticRenderFns } from "./ItemGroupListAddNew.vue?vue&type=template&id=270d9e3d"
import script from "./ItemGroupListAddNew.vue?vue&type=script&lang=js"
export * from "./ItemGroupListAddNew.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupListAddNew.vue?vue&type=style&index=0&id=270d9e3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports